import { render, staticRenderFns } from "./PlansCollective.vue?vue&type=template&id=488b430a"
import script from "./PlansCollective.vue?vue&type=script&lang=js"
export * from "./PlansCollective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports